export function isDocumentElement(el: HTMLElement | typeof window): el is typeof window {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
}

/**
 * Quick fix (type error with npm but not with pnpm. Dunno why)
 */
export function scrollTo(el: HTMLElement | typeof window, top: number): void {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el) && typeof window.scrollTo === 'function') {
        window.scrollTo(0, top);
        return;
    }

    if (el instanceof HTMLElement) {
        el.scrollTop = top;
    }
}

// Get Scroll Parent
// ------------------------------

export function getScrollParent(element: HTMLElement) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;

    if (style.position === 'fixed') return document.documentElement;

    for (let parent: HTMLElement | null = element; (parent = parent.parentElement); ) {
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') {
            continue;
        }
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
            return parent;
        }
    }

    return document.documentElement;
}

export function scrollIntoView(menuEl: HTMLElement, focusedEl: HTMLElement): void {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;

    if (focusedRect.bottom + overScroll > menuRect.bottom) {
        scrollTo(
            menuEl,
            Math.min(
                focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll,
                menuEl.scrollHeight,
            ),
        );
    } else if (focusedRect.top - overScroll < menuRect.top) {
        scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
}
